exports = module.exports = require("../../../../../build/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade[data-v-80340616]{transition:opacity 0.15s linear}@media (prefers-reduced-motion: reduce){.fade[data-v-80340616]{transition:none}}.fade[data-v-80340616]:not(.show){opacity:0}.collapse[data-v-80340616]:not(.show){display:none}.collapsing[data-v-80340616]{position:relative;height:0;overflow:hidden;transition:height 0.35s ease}@media (prefers-reduced-motion: reduce){.collapsing[data-v-80340616]{transition:none}}.accordion-element[data-v-80340616]{border-bottom:solid 1px #dad8da}.collapsed>.icon-chevron-up[data-v-80340616],:not(.collapsed)>.icon-chevron-down[data-v-80340616]{display:none}\n", ""]);

// exports
